import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Fragment } from 'react';

import Text from '~/components/Text';

interface Props {
  title: string;
  description: string | React.ReactElement<any> | number | string;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactElement<any> | number | string;
}

const SlideUpModal = ({ isOpen, onClose, children, title, description }: Props) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-50"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-50"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bottom-0 left-0 z-20 bg-black/60" />
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter="ease-out duration-100"
          enterFrom="transform sm:translate-y-0 translate-y-1/2 opacity-0"
          enterTo="transform translate-y-0 opacity-100"
          leave="ease-in duration-100"
          leaveFrom="transform translate-y-0 opacity-100"
          leaveTo="transform sm:translate-y-0 translate-y-1/2 opacity-0"
        >
          <div className="fixed inset-0 bottom-0 left-0 z-40 flex items-end overflow-y-auto sm:items-center">
            <Dialog.Panel className="relative mx-auto flex w-full max-w-none transform justify-center overflow-auto rounded-t-wt bg-wt-background p-8 text-left align-middle transition-all sm:max-w-xl sm:rounded-wt">
              <div className="relative w-full space-y-4">
                <div className="flex justify-between">
                  <div className="flex flex-col gap-2">
                    <Text as="h4" size="2xl" theme="content">
                      {title}
                    </Text>
                    <Text as="p" size="md" theme="content" weight="regular" className="font-regular">
                      {description}
                    </Text>
                  </div>

                  <div className="h-6 w-6">
                    <button
                      aria-label="Close"
                      className="flex h-6 w-6 items-center justify-center rounded-wt transition-all hover:bg-black/5"
                      onClick={onClose}
                    >
                      <XMarkIcon className="h-5 w-5 stroke-1 text-gray-400 transition-all hover:text-gray-700" />
                    </button>
                  </div>
                </div>

                {children}
              </div>
            </Dialog.Panel>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default SlideUpModal;
